import { type ResourceId } from '@app/client';

const BASE_LID_PATH = '/liquid-id';
export const liquidId = {
    byUserId: (userId: ResourceId) => `${BASE_LID_PATH}/user/${userId}`,
    items: `${BASE_LID_PATH}/items`,
};
